import { Form } from '@magicdoorinc/form';
import { Button, useLocalization } from '@magicdoorinc/ui';
import { onCleanup } from 'solid-js';
import { CompanyTypeConfirmStep, useCompanyTypeConfirm } from '~/contexts/local';
import { BankAccountFormFields } from '~/pages/bank-accounts/components/BankAccountFormFields';
import type { Component } from 'solid-js';

export const CreateCompanyBankAccountContent: Component = () => {
  const { createNewBankAccountForm } = useCompanyTypeConfirm();

  onCleanup(() => {
    createNewBankAccountForm.resetFields();
  });

  return (
    <div class="p-5">
      <Form defaultForm={createNewBankAccountForm} class="flex flex-col gap-5">
        <BankAccountFormFields hideCompanyAccountField />
      </Form>
    </div>
  );
};

export const CreateCompanyBankAccountFooter: Component = () => {
  const { t } = useLocalization();
  const { setStep, handleCreateNewBankAccount } = useCompanyTypeConfirm();

  const handleCancel = () => {
    setStep(CompanyTypeConfirmStep.SelectCompanyBankAccounts);
  };

  return (
    <div class="flex items-center justify-between border-t border-separator bg-white px-5 py-4">
      <Button variant="outlined" onClick={handleCancel}>
        {t('Back')}
      </Button>
      <div class="flex items-center gap-2">
        <Button
          loading={handleCreateNewBankAccount.loading}
          onClick={() => {
            handleCreateNewBankAccount();
          }}>
          {t('Create')}
        </Button>
      </div>
    </div>
  );
};
